import React from "react";
import styles from "./Table.module.scss";
import i18n from "../../../constants/i18n";
import TableItem from "../TableItem";

const RoomsTable = ({
    canViewRoomCheckmarks,
    devices,
    isAdmin,
    rooms,
    onDelete,
    onEdit
}) => {
    return (
        <div>
            <table
                className={`table is-hoverable is-fullwidth ${styles.table}`}
            >
                <thead>
                    <tr>
                        <th>Ruimte</th>
                        <th>
                            <span>
                                <i className="fa fa-id-card" title="Id" />
                            </span>
                        </th>

                        <th>
                            <span>
                                <i className="fa fa-play" title="Player" />
                            </span>
                        </th>
                        <th>
                            <span>
                                <i
                                    className="fa fa-video"
                                    title="Livestreaming"
                                />
                            </span>
                        </th>
                        <th>
                            <span>
                                <i className="far fa-save" title="Opnemen" />
                            </span>
                        </th>
                        {canViewRoomCheckmarks && (
                            <>
                                <th>
                                    <span>
                                        <i
                                            className="fas fa-server"
                                            title={
                                                i18n.roomOverview
                                                    .masterUnitLabel
                                            }
                                        />
                                    </span>
                                </th>
                                <th>
                                    <span>
                                        <i
                                            className="fas fa-route"
                                            title="Bewegwijzering"
                                        />
                                    </span>
                                </th>
                                <th>
                                    <span>
                                        <i
                                            className="fas fa-magic"
                                            title={
                                                i18n.manualImageControl
                                                    .manualPhotoControlLabel
                                            }
                                        />
                                    </span>
                                </th>
                            </>
                        )}
                        {isAdmin && <th></th>}
                    </tr>
                </thead>
                <tbody>
                    {rooms.map((room) => (
                        <TableItem
                            key={room.id}
                            canViewRoomCheckmarks={canViewRoomCheckmarks}
                            devices={devices}
                            isAdmin={isAdmin}
                            room={room}
                            onDelete={onDelete}
                            onEdit={onEdit}
                        />
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default RoomsTable;
